import React from "react";

import { accountContent, sectionHeader, sectionHeaderTitle, sectionHeaderDescription } from "./account-data.module.scss";

import AccountDataForm from "../../auth/forms/account-data-form";

export default function AccountData() {
    return (
        <div className={accountContent}>
            <div className={sectionHeader}>
                <div>
                    <h1 className={sectionHeaderTitle}>Dane konta</h1>
                    <p className={sectionHeaderDescription}>
                        Zarządzaj podstawowymi informacjami o swoim profilu.
                    </p>
                </div>
            </div>
            <AccountDataForm />
        </div>
    );
}
